import React, { useContext, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Box, Button, Dialog } from '@mui/material'

import LanguageContext from '../../../contexts/LanguageContext'
import PopupNotifContext from '../../../contexts/PopupNotifContext'
import closeIcon from '../../../images/closeIcon.svg'

import CertificatReussite from './CertificatReussite'
import { telechargerCertificatPdf } from './pdfCertificat'

/* ⛔ « VOIR MON CERTIFICAT » (06/10/2026, etape 2).
   Une fenetre par-dessus l'ecran ou l'on est (fin de module, « Mon
   résultat ») : ce n'est ni un nouvel ecran ni un nouvel espace. Elle montre
   le certificat tel qu'il sera telecharge, et le bouton « Télécharger mon
   certificat » fabrique le PDF dans le navigateur. Rien n'est envoye au
   serveur. La date affichee est celle du jour : c'est celle du
   telechargement (« Délivré le »). */

/* Le bouton qui ouvre la fenetre, aux deux emplacements : contour noir sur
   fond blanc, coins carres, a cote du bouton principal (noir). */
export const STYLE_BOUTON_CERTIFICAT = {
  fontSize: "16px !important",
  lineHeight: "26px !important",
  letterSpacing: "0px",
  height: ["45px !important", "50px !important"],
  minHeight: ["45px !important", "50px !important"],
  paddingLeft: "20px",
  paddingRight: "20px",
  whiteSpace: "nowrap",
  textTransform: "none",
  borderRadius: "0px",
  color: "#0A0A0B",
  background: "#FFFFFF",
  border: "1px solid #0A0A0B",
  boxShadow: "none",
  "&:hover": { background: "#FAF8F6", border: "1px solid #0A0A0B", boxShadow: "none" },
}

export const BoutonVoirCertificat = ({ onClick, sx }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)
  return (
    <Button
      type="button"
      variant="outlined"
      disableRipple
      data-voir-certificat
      onClick={onClick}
      sx={{ ...STYLE_BOUTON_CERTIFICAT, ...sx }}
    >
      {languageValues?.certificatReussite?.voir?.[actLanguage]}
    </Button>
  )
}

const FenetreCertificat = ({ ouverte, onFermer, prenomNom, nomModule }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)
  const { addPopupNotif } = useContext(PopupNotifContext) || {}
  const [enCours, setEnCours] = useState(false)
  const langue = actLanguage === 'en' ? 'en' : 'fr'

  const telecharger = async () => {
    if (enCours) return
    setEnCours(true)
    try {
      await telechargerCertificatPdf({ prenomNom, nomModule, langue, dateDelivrance: new Date() })
    } catch (e) {
      console.error('certificat : PDF non fabriqué', e)
      if (addPopupNotif) {
        addPopupNotif({ uuid: uuidv4(), title: languageValues?.notifError?.[actLanguage], type: 'error', removeAfter: 5000 })
      }
    }
    setEnCours(false)
  }

  return (
    <Dialog
      open={!!ouverte}
      onClose={onFermer}
      maxWidth="lg"
      fullWidth
      /* au-dessus de la vue d'essai de l'admin (FormationPlayer, zIndex 1400) :
         a 1300 (valeur MUI), la fenetre s'ouvrait DERRIERE elle (banc du
         06/10) ; sans effet ailleurs, rien d'autre n'est entre les deux */
      sx={{ zIndex: 1450 }}
      aria-label={languageValues?.certificatReussite?.mention?.[actLanguage]}
      PaperProps={{
        'data-fenetre-certificat': true,
        sx: {
          borderRadius: '0px',
          margin: ['12px', '32px'],
          width: ['calc(100% - 24px)', 'calc(100% - 64px)'],
          maxHeight: ['calc(100% - 24px)', 'calc(100% - 64px)'],
        },
      }}
    >
      <Box sx={{
        position: 'relative',
        padding: ['44px 12px 16px', '52px 28px 24px', '56px 36px 28px', '56px 36px 28px'],
        /* telephone couche : moins de marges, pour que le bouton reste visible */
        '@media (max-height:450px)': { padding: '40px 16px 14px' },
      }}>
        <Box
          component="button"
          type="button"
          onClick={onFermer}
          aria-label={languageValues?.close?.[actLanguage]}
          sx={{
            position: 'absolute', top: ['8px', '12px'], right: ['8px', '14px'],
            width: '36px', height: '36px', padding: '9px', margin: 0,
            border: 0, background: 'transparent', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <img src={closeIcon} alt="" style={{ width: '18px', height: '18px', display: 'block' }} />
        </Box>
        {/* le certificat ne depasse jamais la hauteur de la fenetre : sur un
            ecran bas (portable, tablette couchee), il retrecit plutot que de
            pousser le bouton hors de vue */}
        <Box sx={{ maxWidth: 'min(100%, calc((100vh - 230px) * 297 / 210))', margin: '0 auto' }}>
          <CertificatReussite prenomNom={prenomNom} nomModule={nomModule} langue={langue} />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: ['16px', '22px'] }}>
          <Button
            type="button"
            variant="contained"
            disableElevation
            disableRipple
            disabled={enCours}
            data-telecharger-certificat
            onClick={telecharger}
            sx={{
              fontSize: "16px !important",
              lineHeight: "26px !important",
              letterSpacing: "0px",
              height: ["45px !important", "50px !important"],
              minHeight: ["45px !important", "50px !important"],
              paddingLeft: "24px",
              paddingRight: "24px",
              whiteSpace: "nowrap",
              textTransform: "none",
              borderRadius: "0px",
            }}
          >
            {languageValues?.certificatReussite?.telecharger?.[actLanguage]}
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}

export default FenetreCertificat
